import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

import { reactive, ref, computed } from 'vue'
import ModalForm from './components/ModalForm.vue'
import { mapsEnum, statusEnum } from './components/enum'
import { getMapConfig, updateMapConfig } from '@/api/systemSetting/index'
import { DcMessage, DcConfirm } from '@dc-platform/dc-components'
import type { MapListItem, MapListResult } from '@/typings/api/systemSetting'


const __default__ = { name: 'DcCosSystemMapManage' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const tableRef = ref()
const queryForm = reactive({})
const tableData = ref<MapListItem[]>([])

const columns = computed(() => [
  {
    title: '地图类型',
    dataIndex: 'mapType',
    dicData: mapsEnum
  },
  { title: '状态', dataIndex: 'status' },
  { title: 'Android Key', dataIndex: 'mapAndroidKey' },
  { title: 'IOS Key', dataIndex: 'mapIosKey' },
  { title: 'Web Key', dataIndex: 'mapWebKey' },
  { title: '操作人', dataIndex: 'operatorName' },
  { title: '操作时间', dataIndex: 'operationTime', width: 190 },

  {
    title: '操作',
    dataIndex: 'action',
    width: 150,
    fixed: 'right'
  }
])

const getList = (queryForm: object, callBack: (res: MapListResult) => void) => {
  getMapConfig().then((res) => {
    tableData.value = res.data
    callBack(res)
  })
}
const fetchTable = () => tableRef.value.fetch()

const modalFormRef = ref<InstanceType<typeof ModalForm>>()
const handleChange = (rows: MapListItem) => {
  modalFormRef.value?.init(rows, tableData.value)
}
const handleStatus = (row: MapListItem) => {
  const params = tableData.value.map((item) => {
    return {
      mapType: item.mapType,
      status: item.mapType === row.mapType ? 0 : 1,
      mapAndroidKey: item.mapAndroidKey,
      mapIosKey: item.mapIosKey,
      mapWebKey: item.mapWebKey
    }
  })
  const mapName = mapsEnum.find((item) => item.value === row.mapType)?.label
  DcConfirm.warning({
    title: '操作提示！',
    content: `启用《${mapName}》地图,其它地图将自动停用,是否确认此操作？`,
    cancelText: '取消',
    okText: '继续',
    onOk() {
      updateMapConfig(params).then(() => {
        DcMessage.success('操作成功')
        fetchTable()
      })
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_dc_status = _resolveComponent("dc-status")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_dc_layout_main, null, {
      default: _withCtx(() => [
        _createVNode(_component_dc_layout_content, null, {
          default: _withCtx(() => [
            _createVNode(_component_cos_table, {
              columns: columns.value,
              onFetch: getList,
              search: queryForm,
              "onUpdate:search": _cache[0] || (_cache[0] = ($event: any) => ((queryForm) = $event)),
              ref_key: "tableRef",
              ref: tableRef,
              needPage: false,
              tableId: "DcCosSystemMapManage"
            }, {
              bodyCell: _withCtx(({ column, record, text }) => [
                (column.dataIndex === 'status')
                  ? (_openBlock(), _createBlock(_component_dc_status, {
                      key: 0,
                      enums: _unref(statusEnum),
                      value: text
                    }, null, 8, ["enums", "value"]))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'action')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (handleChange(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("编辑")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'sys_map_edit_btn']
                      ]),
                      (record.status === 1)
                        ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                            key: 0,
                            type: "link",
                            onClick: ($event: any) => (handleStatus(record))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("启用")
                            ]),
                            _: 2
                          }, 1032, ["onClick"])), [
                            [_directive_permission, 'sys_map_enable_btn']
                          ])
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["columns", "search"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(ModalForm, {
      ref_key: "modalFormRef",
      ref: modalFormRef,
      onFetch: fetchTable
    }, null, 512)
  ], 64))
}
}

})